import { render } from "./PageSidebar.vue?vue&type=template&id=781b4824"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__